
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import '../../pages/style.css'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import axios from 'axios';
import { format } from 'date-fns';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import ServiceCard from '../ServiceCard/ServiceCard';



const Services = ({ data }) => {

    console.log(data, "data")

    const naviagte = useNavigate()
    const { id } = useParams()
    const token = localStorage.getItem('token');

    const [show, setShow] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [index, setIndex] = useState(1);
    const [service_id, setService_id] = useState();
    const [TimeSlots, setTimeSlots] = useState();
    const [Loader, setLoader] = useState(false);
    // const [currentTime, setCurrentTime] = useState(new Date());

    const chooseTime = (service_id, duration) => {
        console.log(duration, "duration")
        setShow(true);
        setService_id(service_id)
        // generateTimeSlots(duration)
    }
    const handleClose = () => {
        setShow(false)
        setIndex(1)
    }
    const handleBack = () => {
        setIndex(1)
    }

    const book = (slotid) => {
        setLoader(true)
        try {
            const data = new FormData();
            data.append('slot_id', slotid)
            data.append('date', selectedDate)
            const body = {
                method: 'POST',
                data: data,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json'
                }
            }
            axios(`https://api.kazbarber.com/api/user/bookings`, body)
                .then((response) => {
                    setLoader(false)
                    console.log(response, "barbar")
                    if (response?.data?.status) {
                        toast.success('appointment done Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        naviagte('/thanks')
                    } else {
                        setLoader(false)
                        console.log(response, "error")
                        toast.error('Something went wrong', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    }
                }).catch((error) => {
                    console.log(error, "error")
                    setLoader(false)
                    toast.error('Something went wrong', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                });
        } catch (error) {
            setLoader(false)
            console.log(error, "error")
            toast.error('Something went wrong', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        console.log(slotid, service_id, "scnscn")
    }

    const getDate = (Date) => {
        const formattedDate = format(Date, 'yyyy-MM-dd');
        setSelectedDate(formattedDate);
        try {
            axios.get(`https://api.kazbarber.com/api/barbers/${id}?date=${formattedDate}`)
                .then((response) => {
                    console.log(response, "slots")
                    setIndex(2)
                    setTimeSlots(response?.data?.data?.services?.find((e) => e?.id === service_id))
                }).catch((error) => {

                    toast.error('Something went wrong', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                });

        } catch (error) {
            console.log(error)
            toast.error('Something went wrong', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    const checktoken = (slotid) => {
        if (token) {
            book(slotid);
        } else {
            naviagte('/login')
        }
    }

    console.log(TimeSlots, "TimeSlots")

    const minDate = new Date();
    return (
        <>
            {Loader ?

                <div className='loader-overlay'>
                    <img src='/assets/images/fancybox_loading@2x.gif' alt='loader' />
                </div>
                :
                <>
                    <div className="container-fluid my-5">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="row">
                                    <div className="col-lg-3">
                                        <div class="our-team-inner">
                                            <div class="our-team-img">
                                                <img src={data?.image} alt="" />
                                            </div>
                                            <div class="our-team-text">
                                                <h5>{`${data?.fname} ${data?.lname}` || <Skeleton />}</h5>
                                                <span>Barber</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-9">
                                        <h1 className="text-center heading">Services</h1>
                                        <hr />
                                        <div className="row mt-1">
                                            {/* <h3 className='text-dark mb-2 text-center'>Cutting Menu</h3> */}

                                            {data?.services?.map((e) => {
                                                return (

                                                    <>
                                                        <ServiceCard e={e} chooseTime={chooseTime} />
                                                    </>
                                                )
                                            })}



                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div >

                    <Modal show={show} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Choose Your Time</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {index === 1 ?
                                <Calendar
                                    onChange={getDate}
                                    value={selectedDate}
                                    minDate={minDate}
                                />
                                : index === 2 ?
                                    <>
                                        <h1 className="text-center heading">Time Slots</h1>
                                        <hr />
                                        <div className="row mt-1">
                                            {/* <h3 className='text-dark mb-2 text-center'>Cutting Menu</h3> */}

                                            {TimeSlots?.timeslots?.map((i) => {
                                                return (

                                                    <>
                                                        <div className="col-md-3">
                                                            {/* <div className="service_card "> */}

                                                            <input type="checkbox" id={i?.id} name="Wash cut and Style" value="155" />
                                                            <label for="Wash cut and Style" className={i?.is_available ? `label-button` : `disable`} onClick={() => i?.is_available ? checktoken(i?.id) : toast.error('Sorry ! Slot Not Available for booking', {
                                                                position: "top-right",
                                                                autoClose: 5000,
                                                                hideProgressBar: false,
                                                                closeOnClick: true,
                                                                pauseOnHover: true,
                                                                draggable: true,
                                                                progress: undefined,
                                                                theme: "light",
                                                            })}>
                                                                <h4>{i?.start_time || <Skeleton />}</h4>
                                                                {/* <h4>{i?.end_time || <Skeleton />}</h4> */}
                                                            </label>

                                                        </div >
                                                    </>
                                                )
                                            })}


                                        </div>
                                    </>
                                    : null
                            }

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleBack}>
                                Back
                            </Button>

                        </Modal.Footer>
                    </Modal>

                </>
            }

        </>
    )
}

export default Services